<div class="d-flex">
  <div class="col-8">
    <h1 class="page-title fw-bold">{{ salutation }}</h1>
    <p *ngIf="homepageModel?.ClientName != null">
      Here's what is going on with your team at {{ homepageModel.ClientName }}
    </p>
  </div>
  <div class="col-4">
    <lib-client-switcher *ngIf="isClientPortal"></lib-client-switcher>
  </div>
</div>
<lib-approvals-tile
  [hasDemographicPermissions]="
    hasAddressPermission || hasDirectDepositPermission
  "></lib-approvals-tile>
<div class="row row-eq-height">
  <ng-container *ngIf="homepageModel != null">
    <div [class]="columnClasses" *ngIf="canViewPayroll || canViewPeople || canManageUsers">
      <lib-todo-tile
        [homePageData]="homepageModel"
        [canAccessPeople]="canViewPeople"
        [canManageUsers]="canManageUsers"></lib-todo-tile>
    </div>
    <div
      [class]="columnClasses"
      *ngIf="
        homepageModel.PayrollTotals != null &&
        homepageModel.PayrollTotals.length > 0 &&
        canViewPayroll
      ">
      <div class="row h-100" *ngFor="let payroll of homepageModel.PayrollTotals">
        <div class="col-12">
          <lib-last-payroll-tile class="h-100" [payroll]="payroll"></lib-last-payroll-tile>
        </div>
      </div>
    </div>
  </ng-container>

  <div
    [class]="columnClasses"
    *ngIf="
      homepageModel?.QuickReports != null && canViewReports && homepageModel.QuickReports.length > 0
    ">
    <div class="row h-100" *ngFor="let report of homepageModel.QuickReports">
      <div class="col-12">
        <lib-quick-reports class="h-100" [report]="report"></lib-quick-reports>
      </div>
    </div>
  </div>
</div>
<div class="row row-eq-height mt-3">
  <div class="col-lg-6" *ngIf="timeclockMapping != null && companySwipeclockIdSynched">
    <lib-connected-products-tile></lib-connected-products-tile>
  </div>
  <div class="col-lg-6">
    <lib-advisors-tile></lib-advisors-tile>
  </div>
</div>
